module.exports = __webpack_public_path__ + "img/sv.8f52682c.png";